export default "__VITE_ASSET__Crut3Yag__"